/**
 * Contextual help (2026-09-28): which guide section the "?" in the top
 * bar opens for the page you're on. Keyed by the numbered section of the
 * Confluence guide (see useHelp), so renaming a page in Confluence
 * doesn't break the mapping — only renumbering would.
 *
 *  1 Getting started · 2 Creating/requesting projects · 3 Project page ·
 *  4 Top Projects + Executive · 5 Capacity/Roster · 6 Intake/Enhancements/
 *  Weekly Update · 7 Field reference
 */
const RULES: Array<[RegExp, number]> = [
  [/^\/portfolio\/[^/]+/, 3],
  [/^\/portfolio/, 2],
  [/^\/request/, 2],
  [/^\/(top-projects|executive|roadmap|departments)/, 4],
  [/^\/(capacity|roster|roles|teams|people)/, 5],
  [/^\/(intake|enhancements|weekly-update|service-desk|application-support)/, 6],
  [/^\/(profile|settings|system|admin|help)/, 1],
];

export function helpSectionFor(pathname: string): number {
  for (const [re, section] of RULES) if (re.test(pathname)) return section;
  return 0;
}
